__turbopack_context__.v({
  "bottomRight": "TreeProgression-module__OGZ6sa__bottomRight",
  "bottomText": "TreeProgression-module__OGZ6sa__bottomText",
  "clouds": "TreeProgression-module__OGZ6sa__clouds",
  "container": "TreeProgression-module__OGZ6sa__container",
  "introText": "TreeProgression-module__OGZ6sa__introText",
  "plantedTrees1": "TreeProgression-module__OGZ6sa__plantedTrees1",
  "plantedTrees10": "TreeProgression-module__OGZ6sa__plantedTrees10",
  "plantedTrees11": "TreeProgression-module__OGZ6sa__plantedTrees11",
  "plantedTrees12": "TreeProgression-module__OGZ6sa__plantedTrees12",
  "plantedTrees13": "TreeProgression-module__OGZ6sa__plantedTrees13",
  "plantedTrees14": "TreeProgression-module__OGZ6sa__plantedTrees14",
  "plantedTrees15": "TreeProgression-module__OGZ6sa__plantedTrees15",
  "plantedTrees2": "TreeProgression-module__OGZ6sa__plantedTrees2",
  "plantedTrees3": "TreeProgression-module__OGZ6sa__plantedTrees3",
  "plantedTrees4": "TreeProgression-module__OGZ6sa__plantedTrees4",
  "plantedTrees5": "TreeProgression-module__OGZ6sa__plantedTrees5",
  "plantedTrees6": "TreeProgression-module__OGZ6sa__plantedTrees6",
  "plantedTrees7": "TreeProgression-module__OGZ6sa__plantedTrees7",
  "plantedTrees8": "TreeProgression-module__OGZ6sa__plantedTrees8",
  "plantedTrees9": "TreeProgression-module__OGZ6sa__plantedTrees9",
  "textContainer": "TreeProgression-module__OGZ6sa__textContainer",
  "topText": "TreeProgression-module__OGZ6sa__topText",
  "treeCount": "TreeProgression-module__OGZ6sa__treeCount",
  "trees": "TreeProgression-module__OGZ6sa__trees",
  "treesContainer": "TreeProgression-module__OGZ6sa__treesContainer",
});
